var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchemesIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7517_11510)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7517_11510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0722 9H14.93C14.7076 9 14.5273 9.17058 14.5273 9.38101V11.4083C14.5273 11.6188 14.7076 11.7893 14.93 11.7893H17.0722C17.2946 11.7893 17.4749 11.6188 17.4749 11.4083V9.38101C17.4749 9.17058 17.2946 9 17.0722 9Z",
    fill: "#FF4F17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5449 15.2109H10.4026C10.1803 15.2109 10 15.3815 10 15.5919V17.6193C10 17.8297 10.1803 18.0003 10.4026 18.0003H12.5449C12.7673 18.0003 12.9475 17.8297 12.9475 17.6193V15.5919C12.9475 15.3815 12.7673 15.2109 12.5449 15.2109Z",
    fill: "#FF4F17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0722 15.2109H14.93C14.7076 15.2109 14.5273 15.3815 14.5273 15.5919V17.6193C14.5273 17.8297 14.7076 18.0003 14.93 18.0003H17.0722C17.2946 18.0003 17.4749 17.8297 17.4749 17.6193V15.5919C17.4749 15.3815 17.2946 15.2109 17.0722 15.2109Z",
    fill: "#FF4F17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5957 15.2109H19.4534C19.231 15.2109 19.0508 15.3815 19.0508 15.5919V17.6193C19.0508 17.8297 19.231 18.0003 19.4534 18.0003H21.5957C21.818 18.0003 21.9983 17.8297 21.9983 17.6193V15.5919C21.9983 15.3815 21.818 15.2109 21.5957 15.2109Z",
    fill: "#FF4F17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1184 12.5443V12.5493H16.4094V12.5443H15.5926V12.5493H11.8836V12.5443H11.2033C11.167 12.5445 11.1323 12.5581 11.1067 12.5824C11.081 12.6067 11.0665 12.6396 11.0664 12.6739V15.6501C11.0665 15.6844 11.081 15.7172 11.1067 15.7414C11.1323 15.7656 11.1671 15.7792 11.2033 15.7792H11.7467C11.7829 15.7792 11.8177 15.7656 11.8434 15.7414C11.869 15.7172 11.8835 15.6844 11.8836 15.6501V13.4523C11.8834 13.435 11.8868 13.4178 11.8937 13.4018C11.9006 13.3858 11.9108 13.3712 11.9238 13.359C11.9367 13.3468 11.9521 13.3371 11.9691 13.3307C11.986 13.3242 12.0042 13.321 12.0225 13.3213H15.4576C15.4756 13.3213 15.4935 13.3246 15.5101 13.3311C15.5268 13.3376 15.5419 13.3471 15.5546 13.3592C15.5673 13.3712 15.5774 13.3855 15.5843 13.4013C15.5911 13.417 15.5946 13.4339 15.5946 13.4509V15.6488C15.5947 15.683 15.6092 15.7159 15.6348 15.7401C15.6605 15.7643 15.6953 15.7779 15.7315 15.7779H16.2749C16.3111 15.7779 16.3459 15.7643 16.3715 15.7401C16.3972 15.7159 16.4117 15.683 16.4118 15.6488V13.4509C16.4117 13.4339 16.4152 13.417 16.4221 13.4013C16.4289 13.3855 16.439 13.3712 16.4518 13.3592C16.4645 13.3471 16.4796 13.3376 16.4962 13.3311C16.5129 13.3246 16.5307 13.3213 16.5487 13.3213H19.9839C20.0019 13.3213 20.0197 13.3246 20.0364 13.3311C20.053 13.3376 20.0681 13.3471 20.0809 13.3592C20.0936 13.3712 20.1037 13.3855 20.1105 13.4013C20.1174 13.417 20.1209 13.4339 20.1208 13.4509V15.6488C20.1209 15.683 20.1354 15.7159 20.1611 15.7401C20.1867 15.7643 20.2215 15.7779 20.2577 15.7779H20.8011C20.8373 15.7779 20.8721 15.7643 20.8978 15.7401C20.9234 15.7159 20.9379 15.683 20.938 15.6488V12.6725C20.9379 12.6382 20.9235 12.6053 20.8978 12.5811C20.8722 12.5568 20.8374 12.5431 20.8011 12.543L20.1184 12.5443Z",
    fill: "#FF4F17"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7517_11510",
    x: 0,
    y: 0,
    width: 31,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.772549 0 0 0 0 0.839216 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7517_11510"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7517_11510",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7517_11510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 9,
    fill: "white",
    transform: "translate(10 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchemesIcon);
export default __webpack_public_path__ + "static/media/schemes_icon.2839ad75fa932df11a072c83e7363ce9.svg";
export { ForwardRef as ReactComponent };